import { concat, hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import can from 'ember-can/helpers/can';
import CpPanel from 'ember-collapsible-panel/components/cp-panel/component';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import { eq } from 'ember-truth-helpers';

import Button from 'umg-ember-backend/components/ui/button';
import { Codemirror } from 'umg-ember-backend/components/ui/codemirror';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);
const STATUS_ICONS = {
  error: 'error',
  running: 'loading',
  success: 'success',
  waiting: 'time',
};

export default class RecordDetailFormsAssetAssetFormatRelationComponent extends Component {
  // Services
  @service flashMessages;
  @service intl;

  // Functions
  priorityLabel = (priority) => {
    return this.t(priority ? 'priority_down' : 'priority_up');
  };

  priorityIcon(priority) {
    return priority ? 'priority-down' : 'priority-up';
  }

  statusIcon(status) {
    return STATUS_ICONS[status];
  }

  rerender = async () => {
    this.args.assetFormatRelation.setProperties({
      flagRedo: '1',
      dateStart: null,
      dateEnd: null,
      priority: 0,
    });

    try {
      await this.args.assetFormatRelation.save();

      this.flashMessages.success(
        'record_detail.forms.asset.asset_format_relation.rerender_success',
      );
    } catch (error) {
      this.flashMessages.serverError(error);
    }
  };

  t = (key, options) => {
    const prefix = 'record_detail.forms.asset.asset_format_relation';

    return this.intl.t(`${prefix}.${key}`, options);
  };

  toggleHighPriority = async () => {
    this.args.assetFormatRelation.priority ^= 1;

    try {
      await this.args.assetFormatRelation.save();
    } catch (error) {
      this.flashMessages.serverError(error);
    }
  };

  // Template
  <template>
    <div class={{(bem)}} ...attributes>
      <CpPanel as |panel|>
        <panel.toggle>
          {{svgJar
            (this.statusIcon @assetFormatRelation.status)
            class=(bem 'status-icon' (hash status=@assetFormatRelation.status))
            data-test-asset-format-relation-status-icon=(this.statusIcon
              @assetFormatRelation.status
            )
          }}
          {{@assetFormatRelation.displayLabel}}
        </panel.toggle>
        <panel.body>
          {{#if @assetFormatRelation.isSourceFormat}}
            {{this.t 'is_source_format'}}
          {{else}}
            <label>{{this.t 'status_label'}}:</label>
            {{this.t
              (concat 'status.' @assetFormatRelation.status)
              priority=@assetFormatRelation.priority
            }}<br />

            {{#if (eq @assetFormatRelation.status 'error')}}
              <label>{{this.t 'convertMessage'}}</label>
              {{@assetFormatRelation.convertMessage}}<br />

              <label>{{this.t 'convertCommandLog'}}</label>
              <Codemirror
                @value={{@assetFormatRelation.convertCommandLog}}
                @readOnly={{true}}
                @mode='shell'
                class={{bem 'convert-command-log'}}
              />
            {{/if}}

            <label>{{this.t 'dateStart'}}:</label>
            {{@assetFormatRelation.dateStart}}<br />

            <label>{{this.t 'dateEnd'}}:</label>
            {{@assetFormatRelation.dateEnd}}<br />

            {{#if (can 'update' @assetFormatRelation)}}
              {{#if (eq @assetFormatRelation.status 'waiting')}}
                <Button
                  @label={{this.priorityLabel @assetFormatRelation.priority}}
                  @icon={{this.priorityIcon @assetFormatRelation.priority}}
                  disabled={{@isDisabled}}
                  {{on 'click' this.toggleHighPriority}}
                />
              {{else}}
                <Button
                  @label={{this.t 'rerender'}}
                  @icon='refresh'
                  disabled={{@isDisabled}}
                  {{on 'click' this.rerender}}
                />
              {{/if}}
            {{/if}}
          {{/if}}
        </panel.body>
      </CpPanel>
    </div>
  </template>
}
